import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { VehicleFormLayout } from "./components/form";

const VehicleEditPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  return (
    <VehicleFormLayout
      mode="edit"
      entityId={id}
      title="Edit Vehicle"
      onSuccess={() => navigate("/vehicles")}
    />
  );
};

export default VehicleEditPage;
